import { createSlice } from '@reduxjs/toolkit';
import { m } from '../../../utils/date';

const initialState = {
    data: [],
    page: {
        page: 1,
        size: 10,
        totalPage: 1,
        totalSize: 2,
    }
};

const materialInSlice = createSlice({
    name: 'materialIn',
    initialState,
    reducers: {
        funGetmaterialIn(state, action){
            const { list, page, size, totalPage, totalSize } = action.payload;
            state.data = list.map(( materialIn ) => {
                return{
                    ...materialIn,
                    wareHousingDt: m.date({ value: materialIn.wareHousingDt }),
                }
            });
            state.page = { page, size, totalPage, totalSize };
        }
    },
});

export const materialInActions = materialInSlice.actions;
export default materialInSlice.reducer;